<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">ZEEBRUGGE</h1>
<p class="subtitle">The Greatest Raid of All</p>
<p class="author">CHRISTOPHER SANDFORD</p>
<div class="pub"><img alt="Image" src="images/logo.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?178751a6